// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-jsx": () => import("/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

